import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Whatsapp, Mailbox, ChatHeart } from "react-bootstrap-icons";
import GetApp from "../components/GetApp";
import { Helmet } from "react-helmet";

function Contact() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact Us</title>
        <link rel="canonical" href="https://boque.me/contact" />
        <meta name="description" content="Get in touch with us." />
      </Helmet>
      <div
        className="header-small"
        style={{ backgroundImage: "url(/images/tile_background.png)" }}
      >
        <Container>
          <Row>
            <Col>
              <h1>Contact Us</h1>
              <p className="mt-3 fs-4">
                Here to help. We are available on the following channels.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="mt-3">
          <Col md={6} className="mt-2">
            <Card>
              <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                <Whatsapp size={50} color="#6434d3" />
                <h4 className="mt-3">WhatsApp</h4>
                <p>+256 763 020500</p>
                <a
                  href="https://wa.me/message/6NF4STFBOAATK1"
                  target="_blank"
                  className="btn btn-primary"
                  rel="noreferrer"
                >
                  Send Message
                </a>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mt-2">
            <Card>
              <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                <Mailbox size={50} color="#6434d3" />
                <h4 className="mt-3">Email</h4>
                <p>team@boque.me</p>
                <a
                  href="mailto:team@boque.me"
                  target="_blank"
                  className="btn btn-primary"
                  rel="noreferrer"
                >
                  Send Email
                </a>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <GetApp />
    </>
  );
}

export default Contact;
